import React from 'react';
import styles from './referrals.module.scss';
import { useTranslation } from 'react-i18next';

import Footer from '../../components/Footer';
import ReferralsForm from '../../components/ReferralsForm';

const renderExternalLinkIcon = () => {
  return (
    <svg fill='#000000' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'>
      <path d='M 25.980469 2.9902344 A 1.0001 1.0001 0 0 0 25.869141 3 L 20 3 A 1.0001 1.0001 0 1 0 20 5 L 23.585938 5 L 13.292969 15.292969 A 1.0001 1.0001 0 1 0 14.707031 16.707031 L 25 6.4140625 L 25 10 A 1.0001 1.0001 0 1 0 27 10 L 27 4.1269531 A 1.0001 1.0001 0 0 0 25.980469 2.9902344 z M 6 7 C 4.9069372 7 4 7.9069372 4 9 L 4 24 C 4 25.093063 4.9069372 26 6 26 L 21 26 C 22.093063 26 23 25.093063 23 24 L 23 14 L 23 11.421875 L 21 13.421875 L 21 16 L 21 24 L 6 24 L 6 9 L 14 9 L 16 9 L 16.578125 9 L 18.578125 7 L 16 7 L 14 7 L 6 7 z' />
    </svg>
  );
};
const ReferralsPage = () => {
  const { t } = useTranslation();

  const renderCurrencyAndAmount = (amount: string) => {
    if (process.env.REACT_APP_CURRENCY === 'usd') {
      return `$${amount}`;
    }
    return `${amount}€`;
  };
  return (
    <>
      <header
        role='banner'
        className={
          styles.ReferralsFormContainer +
          ' h-100 justify-content-center align-items-center mx-auto'
        }
      >
        <div className='d-flex container justify-content-center'>
          <h1 className={styles.Title}>
            {t('refer_a_friend', 'Refer-A-Friend')}
          </h1>
        </div>
        <div className='d-flex container justify-content-center'>
          <div className={styles.ReferralSection}>
            <p>
              {t('zzs_for_free', {
                defaultValue:
                  'Want some Zzzs…for free? Recommend SNOO to your friends, and for each one who rents SNOO (for 1+ months) using your code, you’ll get a {{amount}} gift card, and they will get {{amount}} off their rental!',
                amount: renderCurrencyAndAmount(
                  process.env.REACT_APP_GIFT_CARD_AMOUNT!
                ),
              })}
            </p>
            <a
              className={styles.AboutReferralProgram}
              target='_blanc'
              href='https://www.happiestbaby.com/blogs/snoo/snoo-referral-program'
              aria-label='Opens a new window'
            >
              {t(
                'program_more_info_link',
                'Learn more about our referral program here'
              )}
              <div className='d-inline-flex align-items-center'>
                {renderExternalLinkIcon()}
              </div>
            </a>
          </div>
        </div>
        <ReferralsForm />

        <Footer />
      </header>
    </>
  );
};

export default ReferralsPage;
